// library imports
import { Button, Form, InputNumber, Flex, Skeleton, DatePicker } from "antd";
import { useEffect, useState, useContext } from "react";
import dayjs from "dayjs";
// hook imports
import useFetch from "../../../hooks/useFetch";
// context imports
import { IndexContext } from "../../../context/IndexContext";
// config imports
import { FORM_REQUIRED } from "../../../configs/configs";

export default function TonneProductForm({
  mode,
  setIsModalOpen,
  refreshTable,
  refreshYearList,
  initialValues,
  siteSelected,
  disabledYears,
}) {
  // fetch wrapper
  const [fetchWrapper] = useFetch();

  // loading states
  const [loading, setLoading] = useState(false); // loading state for form
  const [loadingSubmitButton, setLoadingSubmitButton] = useState(false); // loading state for submit button

  const [tonneProductForm] = Form.useForm();

  // load index context
  const { messageApi } = useContext(IndexContext);

  /* API to add tonne product */
  function addTonneProduct(user_inputs) {
    setLoadingSubmitButton(true);
    fetchWrapper({
      endpoint_url: "tonne_product_management/addTonneProduct",
      body: {
        site_id: siteSelected,
        year_selected: user_inputs.Year.format("YYYY"),
        tonne_product: user_inputs.TonneProduct,
      },
      onSuccess: (fetch_output) => {
        messageApi.open({
          type: "success",
          content: fetch_output.message,
        });
        setIsModalOpen(false);
        tonneProductForm.resetFields();
        setLoadingSubmitButton(false);
        refreshTable();
        refreshYearList();
      },
    });
  }

  /* API to edit tonne product */
  function editTonneProduct(user_inputs) {
    setLoadingSubmitButton(true);
    fetchWrapper({
      endpoint_url: "tonne_product_management/editTonneProduct",
      body: {
        tonne_product_id: initialValues[0].ID,
        tonne_product: user_inputs.TonneProduct,
      },
      onSuccess: (fetch_output) => {
        if (fetch_output.data === true) {
          messageApi.open({
            type: "success",
            content: fetch_output.message,
          });
          setIsModalOpen(false);
        } else {
          messageApi.open({
            type: "error",
            content: fetch_output.message,
          });
        }
        tonneProductForm.resetFields();
        setLoadingSubmitButton(false);
        refreshTable();
      },
    });
  }

  useEffect(() => {
    if (mode === "edit") {
      setLoading(true);
      if (initialValues.length) {
        initialValues[0].Year = dayjs(String(initialValues[0].Year), "YYYY");
        tonneProductForm.setFieldsValue(initialValues[0]);
        setLoading(false);
      }
    }
  }, [mode, initialValues]);

  return (
    <>
      {loading ? (
        <Skeleton />
      ) : (
        <Form
          form={tonneProductForm}
          name="tonne-product-form"
          labelCol={{
            span: 12,
          }}
          wrapperCol={{
            span: 12,
          }}
          onFinish={(values) => {
            if (mode === "add") {
              addTonneProduct(values);
            } else {
              editTonneProduct(values);
            }
          }}
          autoComplete="off"
        >
          <Form.Item
            label="Year"
            name="Year"
            rules={[
              {
                required: FORM_REQUIRED,
                message: "Year cannot be empty.",
              },
            ]}
          >
            <DatePicker
              picker="year"
              style={{ width: "100%" }}
              disabled={mode === "edit"}
              // disable year which the tonne product is in database
              disabledDate={(current) => {
                if (!current) return false;
                const year = current.year();
                return disabledYears.includes(year);
              }}
            />
          </Form.Item>

          <Form.Item
            label="Product Produced (Tonne)"
            name="TonneProduct"
            rules={[
              {
                required: FORM_REQUIRED,
                message: "TonneProduct cannot be empty.",
              },
            ]}
          >
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>

          <Flex justify="center">
            <Button
              className="mr-2"
              onClick={() => {
                setIsModalOpen(false);
                tonneProductForm.resetFields();
              }}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              loading={loadingSubmitButton}
            >
              Submit
            </Button>
          </Flex>
        </Form>
      )}
    </>
  );
}
